import {
  buildRootOrigin,
  buildTenantOrigin,
  resolveTenantHost,
  type TenantHostContext,
} from "@repo/shared";
import { getRootDomain } from "@/lib/runtime-config";

// QL-343 — tenant subdomains in the browser. See packages/shared/src/tenant-host.ts
// for the host rules; this file binds them to window.location and runtime config.

/** Which kind of host the app is running on right now. */
export function getTenantHostContext(): TenantHostContext {
  return resolveTenantHost(window.location.host, getRootDomain());
}

function requireRootDomain(): string {
  const root = getRootDomain();
  if (!root) throw new Error("Tenant subdomains are not configured");
  return root;
}

/** Absolute URL on a tenant's host. `pathAndQuery` must start with "/". */
export function tenantUrl(slug: string, pathAndQuery = "/"): string {
  return `${buildTenantOrigin(window.location.protocol, slug, requireRootDomain())}${pathAndQuery}`;
}

/** Absolute URL on the root domain (the organization picker). */
export function rootUrl(pathAndQuery = "/"): string {
  return `${buildRootOrigin(window.location.protocol, requireRootDomain())}${pathAndQuery}`;
}

/** Query param that makes the root login page forget the remembered organization. */
export const SWITCH_ORGANIZATION_PARAM = "switch";

/**
 * Root login page in "change organization" mode. `loginQuery` carries an OAuth
 * sign-in in progress (see isOAuthLogin) across, so it continues on the new host.
 */
export function switchOrganizationUrl(loginQuery?: URLSearchParams): string {
  const params = new URLSearchParams(loginQuery);
  params.set(SWITCH_ORGANIZATION_PARAM, "1");
  return rootUrl(`/login?${params}`);
}
